<form [formGroup]="form">
    <div class="row">
        <div class="col-12 col-lg-6 order-1 order-lg-0">
            <ui-form-input [label]="'global.forms.labels.name' | translate" [formControlName]="partnerFormField.Name" />

            <ui-form-input [label]="'global.forms.labels.email' | translate" [formControlName]="partnerFormField.Email" />

            <ui-form-input [label]="'global.forms.labels.mobilePhone' | translate" [formControlName]="partnerFormField.Phone" />

            <ui-form-input [label]="'global.labels.regNo' | translate" [formControlName]="partnerFormField.RegNo" />

            <ui-form-input
                [formControlName]="partnerFormField.AccountNum"
                [type]="'number'"
                [label]="'users.partner-form.form.labels.accountNum' | translate" />

            <ui-form-textarea [label]="'global.labels.address' | translate" [formControlName]="partnerFormField.Address" />

            <ui-button-row [lyView]="lyView">
                @if (isEditMode) {
                    <ui-button
                        [size]="'lg'"
                        [label]="'global.actions.save' | translate"
                        [disabled]="form?.status === 'INVALID' || pending || !form.dirty"
                        (handlerClick)="handlerSave()" />
                } @else {
                    <ui-button
                        [size]="'lg'"
                        [label]="'global.actions.add' | translate"
                        [disabled]="form?.status === 'INVALID' || pending || !form.dirty"
                        (handlerClick)="handlerCreate()" />
                }
            </ui-button-row>
        </div>
        <div class="col-12 col-lg-5 offset-lg-1 order-0 order-lg-1">
            @if (!isEditMode) {
                <aside class="border rounded pt-2 px-4 pb-4 mb-5">
                    <ui-form-select
                        [searchable]="true"
                        [additionalGroupClass]="'mb-0'"
                        [label]="'users.partner-form.form.labels.fillFromExistingOrganization' | translate"
                        [formControlName]="partnerFormField.OrgId"
                        [bindLabel]="'orgName'"
                        [options]="organizations" />
                </aside>
            }
        </div>
    </div>
</form>
